import { useMemo } from 'react';

import { Typography, useTheme } from '@mui/material';
import { GetSalesInvoice } from 'types/graphql';

import { Card } from 'src/components';
import { useCurrency } from 'src/hooks/useCurrency';
import { invoiceHistoryLogs } from 'src/utils/tableUtils';

import InvoiceHistoryTable from './InvoiceHistoryTable';

interface InvoiceHistoryProps {
    invoice?: GetSalesInvoice['invoice'];
}

const InvoiceHistory = ({ invoice }: InvoiceHistoryProps) => {
    const { currencySymbol } = useCurrency();
    const theme = useTheme();
    const historyLogs = useMemo(() => {
        return invoiceHistoryLogs(invoice, currencySymbol);
    }, [invoice, currencySymbol]);

    return (
        <Card color={theme.palette.text.primary} flex={1} gap="24px">
            <Typography fontSize="20px" fontWeight="500" lineHeight="30px">
                Invoice History
            </Typography>

            <InvoiceHistoryTable historyLogs={historyLogs} />
        </Card>
    );
};
export default InvoiceHistory;
